<template>
  <div>
    <h2>Erklärvideo zur Verwendung des Online Video / Audio Recorders</h2>
    <video class="video" controls>
      <source src="/assets/demo.mp4" type="video/mp4">
    </video>
    <br><br>
    <md-button
      class="md-raised md-primary"
      @click.prevent="onSuccess"
    > fortfahren
      <md-icon>keyboard_arrow_right</md-icon>
    </md-button>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    onSuccess: Function
  },
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  },
  computed: {

  }
}
</script>
<style lang="sass" scoped>
  .video
    width: 50%
    height: 240
  @media (max-width: 550px)
    .video
      width: 100%
      height: 480
</style>
